import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { setPrompt } from '@/reducers/ui/ui.redux'
import { Banner } from '@/components/banners/Banner'
import { usePortal } from '@/utils/hooks/usePortal'
import { useEscapeKey } from '@/utils/hooks/useEscapeKey'

export const Prompt = () => {
  const portal = usePortal()
  const dispatch = useDispatch()
  const { prompt } = useSelector((state) => state.ui)

  const handleClose = () => {
    dispatch(setPrompt(null))
  }

  useEscapeKey(handleClose, Boolean(prompt))

  // Mirror Semantic Portal's closeOnDocumentClick: a click anywhere dismisses
  // the prompt. The effect runs after the interaction that opened the prompt
  // has finished, so it never fires on that opening interaction.
  useEffect(() => {
    if (!prompt) {
      return undefined
    }

    const handleDocumentClick = () => {
      dispatch(setPrompt(null))
    }

    document.addEventListener('click', handleDocumentClick)

    return () => document.removeEventListener('click', handleDocumentClick)
  }, [prompt, dispatch])

  if (!prompt) {
    return null
  }

  const { header, content, ...rest } = prompt

  return portal(
    <Banner large overlay raised header={header} {...rest} onClick={handleClose}>
      {content}
    </Banner>
  )
}
